/**
 * Interactive 3D tilt for product cards. Any element with [data-tilt] leans
 * toward the pointer and exposes --tilt-x / --tilt-y for its glare layer.
 * Only runs for fine pointers with hover and when reduced motion is not requested.
 */
const canTilt = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
const MAX_DEG = 8;
let active = null;
let frame = 0;

function reset(el) {
  el.style.transition = 'transform 500ms cubic-bezier(.2,.8,.2,1)';
  el.style.transform = '';
}

document.addEventListener('pointermove', (event) => {
  if (!canTilt.matches) return;
  const el = event.target instanceof Element ? event.target.closest('[data-tilt]') : null;
  if (active && active !== el) reset(active);
  active = el;
  if (!el) return;
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(() => {
    const rect = el.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width;
    const y = (event.clientY - rect.top) / rect.height;
    el.style.transition = 'transform 120ms ease-out';
    el.style.transform = `perspective(900px) rotateX(${(0.5 - y) * MAX_DEG}deg) rotateY(${(x - 0.5) * MAX_DEG}deg) scale(1.02)`;
    el.style.setProperty('--tilt-x', `${x * 100}%`);
    el.style.setProperty('--tilt-y', `${y * 100}%`);
  });
}, { passive: true });

document.addEventListener('pointerleave', () => { if (active) reset(active); active = null; });
